// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/backgrounds/login-background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginUI_loginView__a-PCE {
  background-color: #5e5d5d;
  width: 100vw;
  height: 100vh;
}

.LoginUI_background__heIYT {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  height: 100vh;
  position: relative;
}

.LoginUI_logoBackground__Im8-s {
  position: absolute;
  left: 20px;
  bottom: 20px;
  width: 80px;
  height: 91px;
  opacity: 0.76;
}

.LoginUI_form__\\+64x4 {
  background-color: #343434;
  padding: 80px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100vh;
  border-bottom: 10px solid var(--orange);
}

.LoginUI_subtitle__eoMan {
  color: var(--gray);
  font-family: BebasNeue;
  font-weight: 700;
  font-size: 20px;
}

.LoginUI_info__jasX0 {
  margin-top: 40px;
  width: 350px;
  padding: 0;
}

.LoginUI_logo__\\+5SvF {
  width: 129.49px;
  height: 147.14px;
  color: white;
  margin-bottom: 20px;
}

.LoginUI_input__zkfJS {
  width: 350px;
  background-color: transparent !important;
  border: none;
  border-bottom: 1px solid var(--gray);
  margin-bottom: 10px;
  color: #c4c4c4 !important;
}

.LoginUI_input__zkfJS input {
  font-weight: 500;
  color: #c4c4c4 !important;
}

.LoginUI_input__zkfJS:hover,
.LoginUI_input__zkfJS:focus {
  border-bottom: 1px solid var(--gray) !important;
}

.LoginUI_submit__z4aIx {
  width: 350px;
  background-color: var(--orange);
  border-color: var(--orange);
  font-weight: 500;
  color: var(--black) !important;
  border-radius: 40px;
  height: 46px;
  margin-top: 40px;
}

.LoginUI_submit__z4aIx:hover,
.LoginUI_submit__z4aIx:focus {
  background-color: var(--orange) !important;
  border-color: var(--orange);
}

.LoginUI_icon__YdIFM {
  color: var(--orange);
  margin-right: 15px;
  margin-left: 10px;
}

.LoginUI_wave1__LuLGJ {
  position: absolute;
  bottom: -10px;
}

.LoginUI_wave2__z4iaI {
  position: absolute;
  bottom: 0;
  right: 0;
}

.LoginUI_powered__ZLwOX {
  position: absolute;
  bottom: 15px;
  z-index: 40;
  font-family: BebasNeue;
}

.LoginUI_powered__ZLwOX a {
  display: flex;
  align-items: center;
  justify-content: center;
}

.LoginUI_powered__ZLwOX span {
  margin-right: 10px;
  display: block;
}

.LoginUI_powered__ZLwOX img {
  width: 150px;
}

@media only screen and (max-width: 576px) {
  .LoginUI_form__\\+64x4 {
    width: 100vw;
    height: 100vh;
    padding: 150px 40px 0 40px;
  }

  .LoginUI_info__jasX0 {
    width: 100%;
  }

  .LoginUI_input__zkfJS,
  .LoginUI_submit__z4aIx {
    width: 100%;
  }

  .LoginUI_wave1__LuLGJ {
    width: 120%;
  }

  .LoginUI_wave2__z4iaI {
    width: 120%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/login/styles/LoginUI.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yDAAyE;EACzE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,2BAA2B;EAC3B,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".loginView {\n  background-color: #5e5d5d;\n  width: 100vw;\n  height: 100vh;\n}\n\n.background {\n  background-image: url(\"../../../assets/backgrounds/login-background.png\");\n  background-size: cover;\n  height: 100vh;\n  position: relative;\n}\n\n.logoBackground {\n  position: absolute;\n  left: 20px;\n  bottom: 20px;\n  width: 80px;\n  height: 91px;\n  opacity: 0.76;\n}\n\n.form {\n  background-color: #343434;\n  padding: 80px 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  height: 100vh;\n  border-bottom: 10px solid var(--orange);\n}\n\n.subtitle {\n  color: var(--gray);\n  font-family: BebasNeue;\n  font-weight: 700;\n  font-size: 20px;\n}\n\n.info {\n  margin-top: 40px;\n  width: 350px;\n  padding: 0;\n}\n\n.logo {\n  width: 129.49px;\n  height: 147.14px;\n  color: white;\n  margin-bottom: 20px;\n}\n\n.input {\n  width: 350px;\n  background-color: transparent !important;\n  border: none;\n  border-bottom: 1px solid var(--gray);\n  margin-bottom: 10px;\n  color: #c4c4c4 !important;\n}\n\n.input input {\n  font-weight: 500;\n  color: #c4c4c4 !important;\n}\n\n.input:hover,\n.input:focus {\n  border-bottom: 1px solid var(--gray) !important;\n}\n\n.submit {\n  width: 350px;\n  background-color: var(--orange);\n  border-color: var(--orange);\n  font-weight: 500;\n  color: var(--black) !important;\n  border-radius: 40px;\n  height: 46px;\n  margin-top: 40px;\n}\n\n.submit:hover,\n.submit:focus {\n  background-color: var(--orange) !important;\n  border-color: var(--orange);\n}\n\n.icon {\n  color: var(--orange);\n  margin-right: 15px;\n  margin-left: 10px;\n}\n\n.wave1 {\n  position: absolute;\n  bottom: -10px;\n}\n\n.wave2 {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n}\n\n.powered {\n  position: absolute;\n  bottom: 15px;\n  z-index: 40;\n  font-family: BebasNeue;\n}\n\n.powered a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.powered span {\n  margin-right: 10px;\n  display: block;\n}\n\n.powered img {\n  width: 150px;\n}\n\n@media only screen and (max-width: 576px) {\n  .form {\n    width: 100vw;\n    height: 100vh;\n    padding: 150px 40px 0 40px;\n  }\n\n  .info {\n    width: 100%;\n  }\n\n  .input,\n  .submit {\n    width: 100%;\n  }\n\n  .wave1 {\n    width: 120%;\n  }\n\n  .wave2 {\n    width: 120%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginView": `LoginUI_loginView__a-PCE`,
	"background": `LoginUI_background__heIYT`,
	"logoBackground": `LoginUI_logoBackground__Im8-s`,
	"form": `LoginUI_form__+64x4`,
	"subtitle": `LoginUI_subtitle__eoMan`,
	"info": `LoginUI_info__jasX0`,
	"logo": `LoginUI_logo__+5SvF`,
	"input": `LoginUI_input__zkfJS`,
	"submit": `LoginUI_submit__z4aIx`,
	"icon": `LoginUI_icon__YdIFM`,
	"wave1": `LoginUI_wave1__LuLGJ`,
	"wave2": `LoginUI_wave2__z4iaI`,
	"powered": `LoginUI_powered__ZLwOX`
};
export default ___CSS_LOADER_EXPORT___;
